export default "__VITE_ASSET__B6x1vQ3Q__"